import React, { Fragment } from "react";
import UserCard from "../user-card";
import { Container, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NotFoundMessage from "../not-found-message";
import StyledUserList from "./styles";

const UserList = ({ users, onUserClick }) => {
  if (!users || !Array.isArray(users)) return null;

  return (
    <StyledUserList>
      <Container maxWidth="md" className="user-list-container">
        <div className="users-container">
          {users.length > 0 ? (
            users.map((data, i) => (
              <Fragment key={`item-${i}`}>
                <UserCard {...data} onUserClick={onUserClick} />
                {i !== users.length - 1 && (
                  <div className="user-divider">
                    <Divider />
                  </div>
                )}
              </Fragment>
            ))
          ) : (
            <NotFoundMessage
              message="Hmmmm....     Parece que no hay resultados para tu búsqueda"
              Icon={SearchIcon}
            />
          )}
        </div>
      </Container>
    </StyledUserList>
  );
};

export default UserList;
